import styled from "styled-components";

export const ColorMarker = styled.div`
    width: 7px;
    height: 7px;
    margin-right: 4px;
    background-color: ${props => props.color || "grey"};
`;
